import { render, staticRenderFns } from "./PageAttributeTable.vue?vue&type=template&id=dcab92f0&"
import script from "./PageAttributeTable.vue?vue&type=script&lang=js&"
export * from "./PageAttributeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports